import {FunctionComponent, HTMLAttributes} from 'react';
import clsx from 'clsx';
import {twMerge} from 'tailwind-merge';

type ElementProps = HTMLAttributes<HTMLDivElement> & {
  isVisible: boolean;
  onClick: () => void;
};

const Backdrop: FunctionComponent<ElementProps> = ({isVisible, onClick, ...props}) => {
  const mergedClasses = clsx(
    'pointer-events-none absolute inset-x-0 bottom-0 top-24 z-20 rounded-b-4 bg-white/80 opacity-0 transition-opacity duration-300',
    isVisible && 'pointer-events-auto opacity-100',
  );

  return <div className={twMerge(mergedClasses)} role="presentation" onClick={onClick} {...props} />;
};

export default Backdrop;
